import { RolePermission } from "./role-permission.model";

export class SectionPermission {
  SectionId: number
  Name: string;
  CanView?: boolean;
  CanAdd?: boolean;
  CanEdit?: boolean;
  CanDelete?: boolean;
  CanActivate?: boolean;
  CanDeactivate?: boolean;
  Roles: RolePermission[];

  constructor() {
    this.CanView = false;
    this.CanAdd = false;
    this.CanEdit = false;
    this.CanDelete = false;
    this.CanActivate = false;
    this.CanDeactivate = false;
    this.Roles = new Array<RolePermission>();
  }
}
